import React, { useMemo } from 'react';
import { Badge, theme } from 'antd';
import type { RibbonProps } from 'antd/es/badge/Ribbon';
import { useAndStore } from '../../base/store/useAndStore';
import { getDataSetStoreKey } from '../../base/storeKeyUtils';
import type { BaseComponentProps, DataSetConfig } from '../../types/common';

export interface AndBadgeRibbonProps extends RibbonProps, BaseComponentProps, DataSetConfig {
  develop?: boolean;
}

export const AndBadgeRibbon: React.FC<AndBadgeRibbonProps> = ({
  id,
  sessionId,
  develop,
  dataSet,
  dataSetField,
  text,
  placement,
  color,
  children,
  ...restProps
}) => {
  const getDataSet = useAndStore((state) => state.getDataSet);
  const dataSetKey = useMemo(
    () => getDataSetStoreKey(sessionId, dataSet),
    [sessionId, dataSet]
  );
  
  const _dataValue = useMemo(() => {
    if (dataSetKey && dataSetField) return getDataSet(dataSetKey, dataSetField);
    return undefined;
  }, [dataSetKey, dataSetField, getDataSet]);

  const effectiveText = useMemo(() => {
    if (_dataValue !== undefined && _dataValue !== null) {
      return _dataValue;
    }
    return text;
  }, [_dataValue, text]);

  // Safely get token
  const tokenResult = theme.useToken ? theme.useToken() : { token: undefined };
  const antdToken = tokenResult.token;
  
  const resolvedColor = useMemo(() => {
    if (!color || typeof color !== 'string') return undefined;
    if (antdToken && color in antdToken) {
       return (antdToken as any)[color];
    }
    return color;
  }, [color, antdToken]);

  return (
    <Badge.Ribbon
      {...restProps}
      text={effectiveText}
      placement={placement}
      color={resolvedColor}
    >
      {/* GrapesJS 注入点 */}
      <div 
        data-slot="content" 
        className="and-badge-ribbon-content-slot"
        style={{ 
          display: 'block', // Ribbon 通常包裹块级卡片
          minHeight: '40px',
          border: develop ? '1px dashed #dedede' : undefined // 开发模式下显示边框辅助视觉
        }}
      >
        {children}
      </div>
    </Badge.Ribbon>
  );
};

export default AndBadgeRibbon;
